import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import {
  DropdownMenuItemRouter,
  PageHeaderDropdownMenu,
} from 'components/Page/Header/PageHeaderDropdownMenu';
import { PostListingLink } from 'components/Post/PostListingLink';
import { NoAmp } from 'containers/NoAmp';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { PageHeaderSeparator } from './PageHeaderSeparator';

export function PageHeaderForOrganizations() {
  return (
    <Hide xs sm md lg>
      <NoAmp>
        <Box classes={['flex', 'align-center']}>
          <PageHeaderSeparator />

          <Box mt="1px">
            <PageHeaderDropdownMenu
              title={() => getText('For Organizations')}
              right
              data-qa-id="for-org-dropdown"
              onClick={() => {
                trackClicked('For Organizations');
              }}
              hideArrow={{
                lg: true,
              }}
            >
              {() => (
                <>
                  <PostListingLink
                    // @ts-expect-error fix type
                    component={DropdownMenuItemRouter}
                    data-qa-id="post-a-listing-dropdown"
                    onClick={() => {
                      trackClicked('Post A Listing', {
                        context: 'Header (For Organizations Dropdown)',
                      });
                    }}
                  >
                    {getText('Post a Listing')}
                  </PostListingLink>
                  <DropdownMenuItemRouter
                    to="/organizations/create"
                    data-qa-id="create-org"
                    onClick={() => {
                      trackClicked('Add Your Organization');
                    }}
                  >
                    {getText('Add Your Organization')}
                  </DropdownMenuItemRouter>
                </>
              )}
            </PageHeaderDropdownMenu>
          </Box>
        </Box>
      </NoAmp>
    </Hide>
  );
}
